import { LtvPredictParams } from '../../entities';
import { LtvPredictService } from '../../interfaces';

export class LtvPredictServiceDecorator implements LtvPredictService {
  constructor(private readonly ltvPredictService: LtvPredictService) {}

  async getLTVPredict(params: LtvPredictParams) {
    return await this.ltvPredictService.getLTVPredict(params);
  }
}
